import { Injectable, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { forLifeOf, LifecycleAware } from '@lsq-frontend/common-ui';
import { CustomerDetailService } from '../../customers/customer-detail/customer-detail.service';
import { DateAsOfReportComponent } from './date-as-of-report.component';

@LifecycleAware()
@Injectable()
export abstract class ByCustomerDateAsOfReportComponent extends DateAsOfReportComponent
    implements OnDestroy {
    public title: string;
    public debtorKey: number;
    public debtorName: string;
    public lastUpdatedDate: Date;

    public customerDetailService: CustomerDetailService;
    private _titleService: Title;

    public ngOnDestroy(): void {}

    public async dispatchInitialRequest(): Promise<void> {
        this.customerDetailService = this.injector.get(CustomerDetailService);
        this._titleService = this.injector.get(Title);

        // Get relationship information.
        this.customerDetailService.relationshipInformationStream
            .pipe(forLifeOf(this))
            .subscribe((relationshipInformation) => {
                this.debtorName = relationshipInformation.debtorName;
                this._titleService.setTitle(`${this.debtorName} - LSQ`);
            });

        // Get some data from the banner data store.
        this.customerDetailService.bannerDataStream
            .pipe(forLifeOf(this))
            .subscribe((bannerData) => {
                this.debtorKey = bannerData.debtorKey;
                this.lastUpdatedDate = bannerData.lastUpdatedDate;
            });

        const initialTake = await this.getTakeFromUserState();
        const initialDateFilter = this.getInitialDateFilter();

        this.configureDatePicker(initialDateFilter);

        this.dataSource.data$.pipe(forLifeOf(this)).subscribe((data) => {
            this.customerDetailService.hideExport = !data.rows.length;
            this.lastUpdatedDate = data.lastUpdatedDate;
            this.updateCustomerDetailBanner();
        });

        this.dataSource.dispatchRequest({
            take: initialTake,
            asOfDateFilter: initialDateFilter,
            debtorKey: this.debtorKey
        });
    }

    public updateCustomerDetailBanner(): void {
        this.customerDetailService.updateBanner({
            title: this.debtorName || this.title,
            debtorName: this.debtorName,
            debtorKey: this.debtorKey,
            lastUpdatedDate: this.lastUpdatedDate,
            reportName: `${this.title} ${this.debtorName}`,
            analyticsName: this.analyticsName,
            apiService: this.apiService,
            datePickerConfiguration: this.datePickerConfiguration
        });
    }
}
